<script setup>
const props = defineProps({
  item: Object,
})

const hours = computed(() => props.item.enrichment.stopwatch.hours.toString().padStart(2, '0'))
const minutes = computed(() => props.item.enrichment.stopwatch.minutes.toString().padStart(2, '0'))
const seconds = computed(() => props.item.enrichment.stopwatch.seconds.toString().padStart(2, '0'))
</script>

<template>
  <div
    class="absolute flex items-center justify-center w-[1810px] h-[728px] top-auto left-[4500px] bottom-[150px] space-x-24 wanted-stopwatch bg-contain bg-no-repeat font-cervo-mono text-white tracking-[-3px] text-[28rem]"
  >
    <div class="absolute bottom-4 right-[1160px]">{{ hours }}</div>
    <div class="absolute bottom-4 right-[725px]">{{ minutes }}</div>
    <div class="absolute bottom-4 right-[290px]">{{ seconds }}</div>
  </div>
</template>

<style scoped>
.wanted-stopwatch {
  background-image: url('../../../assets/images/wanted_stopwatch.png');
}
</style>
